import { createBrowserRouter } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { ProtectedRoute } from '../components/ProtectedRoute';

// Pages
import HomePage from '../pages/HomePage';
import ChatPage from '../pages/ChatPage';
import ChatListPage from '../pages/ChatListPage';
import ProfilePage from '../pages/ProfilePage';
import SettingsPage from '../pages/SettingsPage';
import LoginPage from '../pages/LoginPage';
import SignupPage from '../pages/SignupPage';
import AuthCallbackPage from '../pages/AuthCallbackPage';
import NotFoundPage from '../pages/NotFoundPage';
import SubscriptionSuccessPage from '../pages/SubscriptionSuccessPage';
import SubscriptionCancelPage from '../pages/SubscriptionCancelPage';
import PublicCheckoutPage from '../pages/PublicCheckoutPage';
import CheckoutSuccessPage from '../pages/CheckoutSuccessPage';

export const router = createBrowserRouter([
  // Auth routes (public)
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/signup',
    element: <SignupPage />,
  },
  {
    path: '/auth/callback',
    element: <AuthCallbackPage />,
  },

  // Protected routes with layout (requires subscription)
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'chat',
        element: <ChatListPage />,
      },
      {
        path: 'chat/:companionId',
        element: <ChatPage />,
      },
      {
        path: 'profile',
        element: <ProfilePage />,
      },
      {
        path: 'settings',
        element: <SettingsPage />,
      },
    ],
  },

  // Public checkout routes (no authentication required)
  {
    path: '/checkout',
    element: <PublicCheckoutPage />,
  },
  {
    path: '/checkout/success',
    element: <CheckoutSuccessPage />,
  },

  // Subscription callback routes (public)
  {
    path: '/subscription/success',
    element: <SubscriptionSuccessPage />,
  },
  {
    path: '/subscription/cancel',
    element: <SubscriptionCancelPage />,
  },

  // Catch all - 404
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);

// Route paths constants for easy reference
export const ROUTES = {
  HOME: '/',
  CHAT: '/chat',
  CHAT_WITH_COMPANION: (companionId: string) => `/chat/${companionId}`,
  PROFILE: '/profile',
  SETTINGS: '/settings',
  SUBSCRIPTION_SUCCESS: '/subscription/success',
  SUBSCRIPTION_CANCEL: '/subscription/cancel',
  CHECKOUT: '/checkout',
  CHECKOUT_SUCCESS: '/checkout/success',
  LOGIN: '/login',
  SIGNUP: '/signup',
  AUTH_CALLBACK: '/auth/callback',
} as const;
